import {
  CHANGE_SELECT_LANGUAGE,
  USER_CHAT_LIST,
  XMPP_CLIENT,
  CHAT_HISTORY,
  CHAT_MSG,
  AIRPORT_LIST,
} from "./actionTypes";

const initialState = {
  language: "Tr",
  userchatlist: [],
  chathistory: [],
  xmppclient: {},
  msg: [],
  airport_list: [],
};

export const language = (state = initialState, action) => {
  const { payload, userchatlist, xmppclient, chathistory, msg, airport_list } =
    action;

  switch (action.type) {
    case CHANGE_SELECT_LANGUAGE:
      return {
        ...state,
        language: payload,
      };
    case USER_CHAT_LIST:
      return {
        ...state,
        userchatlist: userchatlist,
      };
    case XMPP_CLIENT:
      return {
        ...state,
        xmppclient: xmppclient,
      };
    case CHAT_HISTORY:
      return {
        ...state,
        chathistory: chathistory,
      };
    case CHAT_MSG:
      return {
        ...state,
        msg: msg,
      };
    case AIRPORT_LIST:
      return {
        ...state,
        airport_list: airport_list,
      };
    default:
      return state;
  }
};
